import { useState, useEffect, useRef } from "react";
import { getAllLocations } from "services/locationService";

const LocationDropdown = ({ buttonText = "S'inscrire aux hebdos" }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      const data = await getAllLocations();
      const activeLocations = data.filter((loc) => loc.active === true);
      setLocations(activeLocations);
    };
  
    fetchLocations();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative lg:ml-8">
      <button
        onClick={() => setDropdownOpen((prev) => !prev)}
        className="flex items-center gap-2 bg-amber-500 text-sm font-bold
          rounded-sm text-white px-2 md:px-4 py-2 hover:bg-amber-600 transition cursor-pointer"
      >
        {buttonText}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transform transition-transform ${
            dropdownOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {dropdownOpen && (
        <ul className="absolute left-0 top-12 md:top-10 w-full bg-gray-900 text-white shadow-xl z-50 overflow-hidden">
          {locations.map((location) => (
            <div key={location.id}>
              <a
                href={`/locations/${location.id}`}
                onClick={() => setDropdownOpen(false)}
                className="block px-4 py-2 hover:bg-amber-700 transition-colors"
              >
                {location.name}
              </a>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationDropdown;
